<template>
  <b-container ref="container" fluid class="position-relative bg-white shadow px-3 pb-5 px-6-lg pb-2-lg w-lg-70">
    <div class="full-mask" v-if="mfsAdmin && !startedByAdmin && !adminEditing"></div>
    <div class="py-3 above-full-mask">
      <b-row>
        <b-col cols="12" lg="4">
          <h2 >Activities</h2>
          <router-link tag="a" :to="`/notification/${notification.id}`">
            Notification #{{notification.fonNumber}}
          </router-link>
        </b-col>
        <b-col>
          <ul ref="errors">
            <li v-for="error in errors" :key="error" class="text-danger">{{error}}</li>
          </ul>
        </b-col>
      </b-row>
    </div>
    <b-form class="pb-lg-0 pb-md-8 pb-0">
      <ValidationObserver ref="observer" slim>
        <HarvestActivitiesForm
          :landownerReport="landownerReport"
          :harvestActivities="model.harvestActivities"
        />
        <NonHarvestActivitiesForm :nonHarvestActivities="model.nonHarvestActivities" />
        <b-card>
          <b-form-row>
            <h5 class="col-12 text-primary font-weight-bold pb-2">
              Additional Information
            </h5>
          </b-form-row>
          <ValidationProvider
            name="Additional Information"
            v-slot="{ errors, classes }"
            slim
          >
            <b-form-group label-cols="12" label-cols-lg="4" label-for="additionalInformation">
              <template v-slot:label>
                Provide information about your harvest that was not addressed by the previous
                questions.
              </template>
              <b-form-textarea
                id="additionalInformation"
                name="additionalInformation"
                v-model="model.additionalInformation"
                placeholder="Enter Additional Information (max 250 characters)"
                maxlength="250"
                rows="3"
                max-rows="8"
                :class="classes"
                :aria-describedby="$errorsIdString(errors, 'additionalInformation')"
              />
              <InputErrors :errors="errors" errorsIdPrefix="additionalInformation" />
            </b-form-group>
          </ValidationProvider>
        </b-card>
      </ValidationObserver>
    </b-form>
    <b-card v-if="adminEditing" class="mt-3">
      <b-form-group label="Editor's Comment" label-for="editorCommentActivities">
        <b-form-textarea
          id="editorCommentActivities"
          v-model="editorComment"
          placeholder="Add a comment about changes made to Activities..."
          rows="3"
          max-rows="6"
          maxlength="255"
        />
      </b-form-group>
    </b-card>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import FormSubmit from '@/mixins/FormSubmit';
import Utilities from '@/mixins/Utilities';
import HarvestActivitiesForm from '@/components/landownerreport/HarvestActivitiesForm.vue';
import NonHarvestActivitiesForm from '@/components/landownerreport/NonHarvestActivitiesForm.vue';

export default {
  name: 'ActivitiesForm',
  props: ['landownerReport'],
  components: {
    HarvestActivitiesForm,
    NonHarvestActivitiesForm,
  },
  mixins: [FormSubmit, Utilities],
  data() {
    const model = {
      harvestActivities: {
        partialCutHarvest: null,
        initialShelterwoodHarvest: null,
        finalShelterwoodHarvest: null,
        clearCutHarvests: [],
        landUseChangeCategoryId: null,
        landUseChangeArea: null,
      },
      nonHarvestActivities: {
        sitePreperationAcres: null,
        releaseAcres: null,
        nonCommercialThinningAcres: null,
        treePlantings: [],
      },
      additionalInformation: null,
    };
    model.additionalInformation = this.landownerReport.additionalInformation;
    model.harvestActivities = this.mergeTargetProps(model.harvestActivities, this.landownerReport);
    model.nonHarvestActivities = this.mergeTargetProps(
      model.nonHarvestActivities,
      this.landownerReport,
    );
    return {
      model,
    };
  },
  mounted() {
    if (this.mfsAdmin && !this.startedByAdmin && !this.adminEditing) {
      if (this.disableTabbing) {
        setTimeout(() => {
          this.disableTabbing(this.$refs.container);
        }, 1500);
      }
    }
  },
  watch: {
    landownerReport() {
      this.model.additionalInformation = this.landownerReport.additionalInformation;
      this.model.harvestActivities = this.mergeTargetProps(
        this.model.harvestActivities,
        this.landownerReport,
      );
      this.model.nonHarvestActivities = this.mergeTargetProps(
        this.model.nonHarvestActivities,
        this.landownerReport,
      );
    },
  },
  computed: {
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    ...mapState('LandownerReport', {
      errors: state => state.activitiesErrors,
    }),
    ...mapGetters('User', ['mfsAdmin']),
    ...mapGetters('LandownerReport', ['adminEditing']),
    editorComment: {
      get() {
        return this.$store.state.LandownerReport.editorComments.activities;
      },
      set(value) {
        this.$store.dispatch('LandownerReport/setEditorComment', { section: 'activities', comment: value });
      },
    },
    startedByAdmin() {
      return this.landownerReport.statusId === 3;
    },
  },
  methods: {
    submitError() {
      const scrollContainer = document.querySelector('.wizard-tab-content,.fullContent');
      this.$scrollTo(this.$refs.errors, {
        container: scrollContainer || 'body',
      });
    },
    async submitWrapper() {
      const submitDto = { ...this.model };
      // Harvest Activities info not required
      if (!this.landownerReport.harvest) submitDto.harvestActivities = null;
      const action = this.adminEditing
        ? 'LandownerReport/adminUpdateActivities'
        : 'LandownerReport/updateActivities';
      return this.submit(
        this.$refs.observer,
        action,
        submitDto,
      );
    },
  },
};
</script>
